import { useEffect, useRef, type ReactNode } from 'react';
import { X } from './Icons';

/** Native <dialog>: focus trap, Escape and inert background come from the platform. */
export function Modal({
  open,
  onClose,
  title,
  children,
  wide,
  footer,
  describedBy,
}: {
  open: boolean;
  onClose(): void;
  title: string;
  children: ReactNode;
  wide?: boolean;
  footer?: ReactNode;
  describedBy?: string;
}) {
  const ref = useRef<HTMLDialogElement>(null);
  useEffect(() => {
    const d = ref.current;
    if (!d) return;
    if (open && !d.open) d.showModal();
    if (!open && d.open) d.close();
  }, [open]);
  return (
    <dialog
      ref={ref}
      className={`modal ${wide ? 'modal--wide' : ''}`}
      aria-labelledby="modal-title"
      aria-describedby={describedBy}
      onClose={onClose}
      onClick={(e) => {
        if (e.target === ref.current) onClose();
      }}
    >
      {open && (
        <div className="modal__body">
          <header className="modal__head">
            <h2 id="modal-title" className="modal__title">
              {title}
            </h2>
            <button
              type="button"
              className="btn btn--quiet btn--icon"
              onClick={onClose}
              aria-label="Close"
            >
              <X />
            </button>
          </header>
          <div className="modal__content" tabIndex={0} role="region" aria-labelledby="modal-title">
            {children}
          </div>
          {footer && <footer className="modal__foot">{footer}</footer>}
        </div>
      )}
    </dialog>
  );
}
